<template>
    <div>
        <div class="box-content relative flex flex-col md:flex-row justify-center gap-4 md:px-[40px] lg:px-[100px]">
            <h3 class="absolute text-sm md:text-lg top-2 left-4 md:top-10 md:left-10 font-semibold uppercase text-teal-500 font-sans">Students' Life</h3>
            <div class="relative my-4 lg:my-8 md:pt-6 flex flex-col lg:flex-row justify-center gap-4">
                <div class="relative order-1 lg:order-2 h-40 md:h-60 lg:h-fit">
                    <img class="object-cover object-center w-full h-full lg:w-[500px] lg:h-64 rounded-tr-full rounded-bl-full" src="@/assets/img/student/student.jpg" alt="student-image">
                </div>
                <div class="relative z-10 order-2 lg:order-1 w-full lg:max-w-[600px] py-2 lg:px-8 lg:py-4 text-center my-auto">
                    <h3 class="text-orange-900 uppercase font-normal text-2xl sm:text-4xl lg:text-5xl">Đời sống sinh viên</h3>
                    <p class="text-justify my-3 lg:my-6 font-light text-md sm:text-lg"><i>"Tại HUET, bạn sẽ được trải nghiệm nền giáo dục giúp bạn hướng đến thành công, trang bị cho bạn những kiến thức và kỹ năng để trở thành người xuất sắc trong nghề nghiệp mà bạn chọn."</i></p>
                    <div class="flex flex-col sm:flex-row justify-center gap-2">
                        <a id="content" class="btn btn-outline-dark mx-1" style="border-radius: 100px;" href="#content">Tìm hiểu ngay</a>
                        <a class="btn btn-dark mx-1" style="border-radius: 100px;" target="_blank" href="https://online.anyflip.com/fauzr/sxcs/mobile/index.html">Sổ tay sinh viên</a>
                    </div>
                </div>
                <div data-aos="fade-right" data-aos-duration="1500" class="absolute z-0 top-0 left-0 md:left-12 hidden md:block">
                    <h3 class="text-transparent text-7xl md:text-[150px] lg:text-[200px] text-center font-outline-4">HUET</h3>
                </div>
            </div>
        </div>
        <div class="box-content !pt-0 relative md:px-[40px] lg:px-[100px]">
            <h3 class="text-xl md:text-2xl font-semibold w-fit pb-1 sm:pb-2 text-prime-color text-justify">Nằm trong môi trường truyền thống  giáo dục chất lượng của Đại học Huế, khoa Kỹ Thuật và Công Nghệ đang xây dựng thương hiệu trong khu vực và khắp cả nước. Nhà trường luôn chú trọng đào tạo cung ứng nguồn nhân lực chất lượng cao trong giai đoạn cuộc Cách mạng công nghệ 4.0.</h3>
            <h4 class="text-lg md:text-xl text-justify">Chúng tôi cung cấp cho sinh viên dịch vụ hỗ trợ đa dạng cùng trang thiết bị tiên tiến. Hãy đến hòa nhập vào cộng đồng sôi động và thân thiện của HUET, cùng hưởng ứng những hoạt động văn hóa, xã hội, thể thao, giải trí - có vô vàn cách để bạn tham gia cùng chúng tôi.</h4>
            <div class="flex flex-col md:flex-row justify-center gap-4 mt-4">
                <div class="px-[10px] grid grid-cols-1 md:grid-cols-2 lg:flex gap-[8px] md:gap-[16px] lg:gap-5 xl:gap-10 justify-around lg:justify-center">
                    <div class="flex flex-col gap-2 lg:mt-4 max-w-[340px] min-w-[260px] mx-auto lg:ml-auto">
                        <img v-viewer src="@/assets/img/student/student-1.jpg" class="image_hover w-52 h-52 lg:w-56 lg:h-56 mx-auto rounded-full object-cover object-center p-0 cursor-pointer">
                        <div class="pt-[8px] md:pt-0">
                            <h2 class="header-text">Câu lạc bộ Sinh viên</h2>
                            <p class="content-text">Gặp gỡ những người bạn cùng sở thích và niềm đam mê, tham gia vào cộng đồng các câu lạc bộ sinh viên, và bạn có thể có câu lạc bộ của riêng mình.</p>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2 max-w-[340px] min-w-[260px] mx-auto">
                        <img v-viewer src="@/assets/img/student/student-2.jpg" class="image_hover w-52 h-52 lg:w-60 lg:h-60 mx-auto rounded-full object-cover object-center p-0 cursor-pointer">
                        <div class="pt-[8px] md:pt-0">
                            <h2 class="header-text">Hỗ trợ sinh viên</h2>
                            <p class="content-text">Với mong muốn đem lại cho sinh viên những trải nghiệm học tập khó quên, nhanh chóng thích nghi và có thời gian đại học tươi đẹp nhất.</p>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2 md:col-span-2 lg:col-span-1 lg:mt-4 max-w-[340px] min-w-[260px] mx-auto lg:mr-auto">
                        <img v-viewer src="@/assets/img/student/student-3.jpg" class="image_hover w-52 h-52 lg:w-56 lg:h-56 mx-auto rounded-full object-cover object-center p-0 cursor-pointer">
                        <div class="pt-[8px] md:pt-0">
                            <h2 class="header-text">Thực tập doanh nghiệp</h2>
                            <p class="content-text">Cùng khám phá những cơ hội tuyệt vời dành cho sinh viên HUET, từ hoạt động tình nguyện đến dịch vụ hướng nghiệp.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="relative w-full">
            <Banner class="d-none d-md-block" />
            <div class="md:mx-[60px] lg:mx-[100px] py-[16px] md:py-2 px-3 bg-gray-100 md:absolute md:bg-slate-50/70 md:backdrop-blur-sm bottom-0 z-10">
                <h4 class="text-center font-semibold text-blue-800 text-xl lg:text-2xl">Nguồn tài liệu đa dạng</h4>
                <p class="text-justify text-lg lg:text-xl !font-extralight md:mb-1">Nằm trong môi trường truyền thống  giáo dục chất lượng của Đại học Huế, khoa Kỹ Thuật và Công Nghệ đang xây dựng thương hiệu trong khu vực và khắp cả nước. Nhà trường luôn chú trọng đào tạo cung ứng nguồn nhân lực chất lượng cao trong giai đoạn cuộc Cách mạng công nghệ 4.0.</p>
            </div>
        </div>
        <div class="box-content relative md:px-[40px] lg:px-[100px] grid grid-cols-12 gap-4 lg:gap-8">
            <div class="flex flex-col gap-3 col-span-12 lg:col-span-9">
                <div>
                    <h4 class="font-semibold text-xl lg:text-2xl mb-1">1. Không gian học</h4>
                    <p class="text-lg text-justify">
                        Khoa Kỹ Thuật và Công nghệ – Đại học Huế hướng đến chủ trương đổi mới – sáng tạo với phương châm lấy “sinh viên làm trọng tâm”. Một môi trường học tập năng động, hiện đại để hoàn thiện và phát triên bản thân. Sinh viên được trải nghiệm với không gian học tập mở đem đến một môi trường học tập thân thiện và giàu cảm hứng. Với các kiểu phòng học được thiết kế theo tiêu chuẩn quốc tế, tất cả đều được trang bị điều hòa, máy chiếu và phủ sóng wifi phục vụ cho công tác giảng dạy, học tập. Ngoài ra phòng thực hành được trang bị những thiết bị tiên tiến hiện đại như Robot giúp sinh viên có thể chế tạo được các sản phẩm trong kế hoạch học tập.
                    </p>
                </div>
                <div>
                    <h4 class="font-semibold text-xl lg:text-2xl mb-1">2. Cơ sở đào tạo</h4>
                    <p class="text-lg text-justify">
                        Cơ sở  1 : 01 Điện Biên Phủ, Thành phố Huế<br>Cơ sở 2 : 05 Hà Nội , Thành phố Huế    
                    </p>
                </div>
                <div>
                    <h4 class="font-semibold text-xl lg:text-2xl mb-1">3. Ký túc xá</h4>
                    <p class="text-lg text-justify">
                        Sinh viên của Kỹ thuật và Công nghệ có thể đăng ký ở tại Ký túc xá sinh viên của Đại học Huế tại:
                        <br>– KTX Trường Bia: 2.766 m2
                        <br>– KTX Đống Đa : 2.181 m2
                        <br>– KTX Tây Lộc : 3.114 m2 
                    </p>
                </div>
                <div>
                    <h4 class="font-semibold text-xl lg:text-2xl mb-1">4. Môi trường sống</h4>
                    <p class="text-lg text-justify mb-2">
                        Huế được xem là một thành phố xanh Quốc gia. Ở nơi đây đã thu hút hàng ngàn du khách trên Thế giới với những cung thành, cung điện cổ kính vàng son, những đền miếu lộng lẫy và những danh lam lâu đời vẫn còn được lưu giữ. Ngoài ra Huế còn là “Kinh đô ẩm thực”, các món ăn sang trọng hay những món ăn bình dị đều thể hiện đậm nét giá trị văn hóa, lịch sử mang đậm bản chất “Ngon – Bổ – Rẻ”. Sinh viên được học tập ở Huế,  trong môi trường an toàn, hiếu khách và chi phí học tập hợp lý chưa đến 20 triệu cho một năm học.
                    </p>
                    <p class="text-lg text-justify">
                        Là một thành phố thú vị với nhiều hoạt động dành cho sinh viên như giao lưu văn nghệ, acoustic, flashmod, vẽ tranh đường phố . Với chất lượng không khí ít khói bụi, không ảnh hưởng đến sức khỏe, sinh viên tự do thực hiện các hoạt động ngoài trời như đạp xe, đi bộ, dã ngoại và nhiều hoạt động tình nguyện về lễ hội như Festival, mùa hè xanh diễn ra quanh năm.  Đây là những điều sẽ giúp cho sinh viên trở thành một con người năng động, hòa đồng và phát triển các kỹ năng mềm.
                    </p>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-3">
                <h4 class="text-xl md:text-2xl font-semibold text-left mb-2">Tin tức liên quan</h4>
                <div v-if="!loading" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-1 gap-4">
                    <div v-for="(entry, index) in entries" :key="index" :class="{'d-none': index>3}">
                        <div class="shadow-lg shadow-black bg-white w-full h-fit relative" :class="{'sm:hidden md:block lg:hidden': index == 3}">
                            <img :src="$addPrefix(entry.image)" class="w-full h-[150px] sm:h-[120px] lg:h-[150px] object-cover object-center cursor-pointer" alt="news-thumbnail" @click="pushNewsDetail(entry._id)">
                            <div class="px-[8px] py-2 md:px-3 flex flex-col gap-2">
                                <h5 class="mb-0 font-semibold cursor-pointer truncate" @click="pushNewsDetail(entry._id)">{{ entry.name }}</h5>
                                <p class="line-clamp-2 w-full mb-0">{{ entry.description }}</p>
                                <div class="flex justify-between">
                                    <p class="mb-0 text-gray-400 font-semibold">{{ getDateTime(entry.updatedAt) }}</p>
                                    <p class="mb-0 pr-2 hover:text-prime-color cursor-pointer font-semibold" @click="pushNewsDetail(entry._id)">Đọc ngay</p>
                                </div>
                            </div>
                            <b-badge variant="warning" class="absolute top-3 left-3"><h6 class="mb-0 font-semibold">{{ entry.type }}</h6></b-badge>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <Loading />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Banner from '@/components/banner'
import Loading from '@/components/loading'
import { mapActions } from 'vuex';
export default {
    components: {
        Banner, Loading
    },
    data() {
        return {
            entries: [],
            loading: true
        }
    },
    methods: {
        ...mapActions('news', ['GetLatestNewsList']),
        async getEntry(){
            let response = await this.GetLatestNewsList("Sinh viên")
            this.entries = response.data.data
            this.loading = false
        },
        getDateTime(rawData) {
            return rawData.substring(8, 10) + '-' + rawData.substring(5, 7) + '-' + rawData.substring(0, 4)
        },
        pushNewsDetail(id) {
            this.$router.push({path: '/news/detail/' + id})
        }
    },
    created() {
        this.getEntry()
    },
}
</script>